// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VLArp","name":"styles_name__3ntUk","phone":"styles_phone__2Ogzj"};